import { render, staticRenderFns } from "./search-tip.vue?vue&type=template&id=1c0fbe27&scoped=true&"
import script from "./search-tip.vue?vue&type=script&lang=js&"
export * from "./search-tip.vue?vue&type=script&lang=js&"
import style0 from "./search-tip.vue?vue&type=style&index=0&id=1c0fbe27&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0fbe27",
  null
  
)

export default component.exports